export enum CommentTypeEnum {
  EMOTE = 'EMOTE',
  GIF = 'GIF',
  WEBCAM = 'WEBCAM',
  SCREEN = 'SCREEN',
  TEXT = 'TEXT',
}
